import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'

import { SafeFlagImg } from '../components/SafeImgs'

import WithForcedMonospace from '../components/WithForcedMonospace'
import WithPodiumStyles from '../components/WithPodiumStyles'

import { getFormattedDelta } from '../utils'

// import FlipMove from 'react-flip-move'

import { useStore } from '../zustandStore'

const SubmissionsLargeFullGameEntry = forwardRef(({ submission, isPlaceholder, maxRankDigits }, ref) => {

  const {
    player,
  } = useStore(
    state => ({
      player: state.players.find(p => p.slug === submission.playerSlug)
    })
  )

  const isCurrentPlayerBestTime = submission.time == player.eventBestTimes[submission.chapterName]

  return (
    <StyleWrapper className='submission-wrapper' ref={ref} hasDelta={!!submission.delta} isPlaceholder={isPlaceholder} isCountryPresent={player.isCountryPresent}>
      <PlayerTitle className='player-title'>
        {player.completedAllChapters && (
          <Rank className='rank' maxRankDigits={maxRankDigits}>
            <WithForcedMonospace>{player.rank}</WithForcedMonospace>
          </Rank>
        )}
        <Name className='name'>
          {player.name}
        </Name>
        {player.isCountryPresent && (
          <Flag className='flag'>
            <SafeFlagImg {...player} />
          </Flag>
        )}
      </PlayerTitle>
      {submission.delta && (
        <div className='delta'>
          <WithForcedMonospace>
            {getFormattedDelta(submission.delta)}
          </WithForcedMonospace>
        </div>
      )}
      <div className='submitted-time'>
        {isCurrentPlayerBestTime
          ? (
            <WithPodiumStyles rank={player.rank}>
              {submission.time}
            </WithPodiumStyles>
          ) : (
            <WithForcedMonospace>
              {submission.time}
            </WithForcedMonospace>
          )
        }   
      </div>
    </StyleWrapper>
  )
})

export default SubmissionsLargeFullGameEntry

const StyleWrapper = styled.div`
  display: grid;
  width: 96%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0.05em;
  padding-bottom: 0.15em;
  background-color: var(--panel-title-obs-color-lighter);

  ${props => props.isPlaceholder ? css`
    opacity: 0 !important;
    color: #0000 !important;
    border: 2px solid #0000;
  ` : css`
    border: 2px solid #aaa;
    border-radius: 5px;
  `}

  font-size: 2.5em;
  
  ${props => props.hasDelta ? css`
    grid-template-columns: 7fr min-content 5fr;
  ` : css`
    grid-template-columns: 1fr 0fr min-content;
  `}

  white-space: nowrap;
  * {
    white-space: nowrap;
  }
  .rank {
    grid-column: 1;
    line-height: 0.4em;
  }
  .name {
    grid-column: 2;
    max-width: 100%;
  }
  .flag {
    grid-column: 3;
  }
  .delta {
    grid-column: 2;
    text-align: center;
    &:not(.first-submission) {
      color: var(--time-saved-delta-color);
    }
  }
  .submitted-time {
    grid-column: 3;
    text-align: right;
    padding-right: 0.3em;
  }
  .delta, .submitted-time {
    font-size: 1.25em;
  }
`

const PlayerTitle = styled.div`
  grid-row: 1;
  grid-column: 1;
  display: grid;
  width: 100%;
  /* background-color: var(--panel-title-obs-color); */
  max-width: 100%;
  ${'' /* overflow: hidden; */}
  grid-template-columns: min-content auto 1fr;
  font-size: 1.15em;
`

const Flag = styled.div`
  --flag-width: 55px;
  margin: auto calc(var(--flag-width) * 0.15);

  > img {
    width: var(--flag-width);
    height: calc(var(--flag-width) * (2/3));
  }
  line-height: 1em;
`

const Name = styled.div`
  /* grid-row: 1;
  grid-column: 2; */
  ${'' /* line-height: 1.4em; */}
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* line-height: 0.9em; */
  margin-left: 0.2em;
  margin-top: auto;
  margin-bottom: auto;
`
const Rank = styled.div`
  /* grid-row: 1;
  grid-column: 1; */
  color: var(--rank-color);
  display: flex;
  font-weight: bold;
  align-items: center;
  padding-top: 10px;
  justify-content: center;
  font-size: 0.6em;
  margin-left: 0.4em;
  ${props => css`
    min-width: ${0.5 * props.maxRankDigits}em;
  `}
  ${'' /* margin-bottom: 0.1em; */}
`